import { Language } from 'prism-react-renderer'

export const supportedLang = new Set<Language>([
  'markup',
  'bash',
  'clike',
  'c',
  'cpp',
  'css',
  'javascript',
  'jsx',
  'coffeescript',
  'actionscript',
  'css-extr',
  'diff',
  'git',
  'go',
  'graphql',
  'handlebars',
  'json',
  'less',
  'makefile',
  'markdown',
  'objectivec',
  'ocaml',
  'python',
  'reason',
  'sass',
  'scss',
  'sql',
  'stylus',
  'tsx',
  'typescript',
  'wasm',
  'yaml',
])

const langMap: Record<string, Language> = {
  html: 'markup',
  js: 'javascript',
  regexp: 'javascript',
}

export function getLanguage(lang?: string | null): Language {
  if (!lang) return 'markup'
  const langLowerCase = lang.toLowerCase() as Language
  if (supportedLang.has(langLowerCase)) {
    return langLowerCase
  }
  if (langMap[langLowerCase]) return langMap[langLowerCase]
  return 'markup'
}
